import { render, staticRenderFns } from "./CashAssetsFS.vue?vue&type=template&id=06bb8568&scoped=true"
import script from "./CashAssetsFS.vue?vue&type=script&lang=ts"
export * from "./CashAssetsFS.vue?vue&type=script&lang=ts"
import style0 from "./CashAssetsFS.vue?vue&type=style&index=0&id=06bb8568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb8568",
  null
  
)

export default component.exports